import React from "react";
import { Box, Link } from "@mui/material";

interface NameCellProps {
  primaryText: string;
  secondaryText?: string;
  onClick?: () => void;
  /** Iniciais no quadrado à esquerda (redesign V3). Sem valor, sem avatar. */
  avatar?: string;
  /** Cor do avatar, pelo status do perfil. */
  avatarTone?: "green" | "yellow" | "red" | "grey" | "brand";
}

const TONES = {
  green: { bg: "#E6F4EA", fg: "#137333" },
  yellow: { bg: "#FEF7E0", fg: "#B06000" },
  red: { bg: "#FCE8E6", fg: "#C5221F" },
  grey: { bg: "#F1F3F4", fg: "#5F6368" },
  brand: { bg: "#EAF1FB", fg: "#0B4FA8" },
};

export const NameCell: React.FC<NameCellProps> = ({
  primaryText,
  secondaryText,
  onClick,
  avatar,
  avatarTone = "brand",
}) => {
  const tone = TONES[avatarTone];
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "12px", minWidth: 0 }}>
      {avatar && (
        <Box
          aria-hidden="true"
          sx={{
            width: 40,
            height: 40,
            borderRadius: "12px",
            background: tone.bg,
            color: tone.fg,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "var(--font-sans)",
            fontSize: 14,
            fontWeight: 500,
            flexShrink: 0,
          }}
        >
          {avatar}
        </Box>
      )}
      <Box sx={{ display: "flex", flexDirection: "column", gap: "2px", minWidth: 0, fontFamily: "var(--font-sans)" }}>
        <Link
          component="button"
          variant="body2"
          onClick={onClick}
          sx={{
            fontFamily: "var(--font-sans)",
            fontWeight: 500,
            fontSize: 14,
            color: "var(--ink)",
            textAlign: "left",
            textTransform: "none",
            textDecoration: "none",
            cursor: onClick ? "pointer" : "default",
            "&:hover": { color: "var(--brand)", textDecoration: "underline" },
          }}
        >
          {primaryText}
        </Link>
        {secondaryText && (
          <Box
            component="span"
            sx={{
              fontSize: 12,
              color: "var(--text-muted)",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: 320,
            }}
            title={secondaryText}
          >
            {secondaryText}
          </Box>
        )}
      </Box>
    </Box>
  );
};
